import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  paymentCurrentStep: 1,
}

export const paymentScreenViewSlice = createSlice({
  name: 'paymentScreenView',
  initialState,
  reducers: {
    nextPaymentStep(state) {
      state.paymentCurrentStep += 1
    },
    prevPaymentStep(state) {
      if (state.paymentCurrentStep !== 1) {
        state.paymentCurrentStep -= 1
      }
    },
    setPaymentStep(state, action) {
      state.paymentCurrentStep = action.payload
    },
  },
})

export const {nextPaymentStep, prevPaymentStep, setPaymentStep} =
  paymentScreenViewSlice.actions
export default paymentScreenViewSlice.reducer
